import React from 'react';
import RegisterForm from '../../components/auth/RegistrationForm/RegistrationForm';

const Register = () => (
    <RegisterForm />
)

export default Register;
